'use strict';
const accountTypes = {
	'mindmup-gold': {
		isDomainAccount: false,
		cognitoAuthenticated: true,
		otpAuthenticated: true,
		otpEmailtoPrimary: true,
		subAccountRequired: false,
		teamdriveAvailable: false,
		payByInvoiceAllowed: false,
		subteamsAvailable: false
	},
	'mindmup-gold-team': {
		isDomainAccount: false,
		cognitoAuthenticated: true,
		otpAuthenticated: true,
		subAccountRequired: true,
		defaultSubAccount: '_',
		defaultSubAccountRole: 'primary',
		teamdriveAvailable: true,
		payByInvoiceAllowed: false,
		subteamsAvailable: true
	},
	'mindmup-gold-domain': {
		isDomainAccount: true,
		cognitoAuthenticated: false,
		otpAuthenticated: false,
		subAccountRequired: true,
		teamdriveAvailable: true,
		payByInvoiceAllowed: true,
		subteamsAvailable: true
	}
};
module.exports = function getAccountTypeInfo(accountType) {
	const accountTypeInfo = accountType && accountTypes[accountType];
	if (!accountTypeInfo) {
		throw new Error('invalid-args');
	}
	return Object.assign({}, accountTypeInfo);
};
